import noUiSlider from 'nouislider';
import { ajaxSpinner } from '../util/ajaxSpinner';

export default {
  init() {

  },
  finalize() {
    const $loadMore = $('#load-more');

    var in_progress = false;

    function load_products(ignore_price = true) {


      if (in_progress)
        return;
      else {
        $loadMore.hide();
        in_progress = true;
      }

      const spinner = new ajaxSpinner($('.products-container'));

      freeze_filters();

      // Categories
      var categories = null;
      var all_categories = false;

      if ($('#category-all').prop('checked')) {
        all_categories = true;
      }

      $('input[name="product_cat"]').each(function () {
        if ($(this).prop('checked')) {
          if (all_categories && $(this).val() != 'category-all') {
            $(this).prop('checked', false);
          } else {
            if (!all_categories) {
              if (categories == null) {
                categories = [$(this).val()];
              } else {
                categories.push($(this).val());
              }
            }
          }
        }
      });

      // Sorting type
      var orderby = null;
      var order = null;
      var meta_key = null;

      const sortSelected = $('select[name="orderby"] option:selected').val();

      if (sortSelected == 'menu_order') {
        orderby = 'menu_order';
        order = 'DESC';
        meta_key = '';
      } else if (sortSelected == 'popularity') {
        orderby = 'meta_value_num';
        order = 'DESC';
        meta_key = 'rating';
      } else if (sortSelected == 'date') {
        orderby = 'modified';
        order = 'DESC';
        meta_key = '';
      } else if (sortSelected == 'price') {
        orderby = 'meta_value_num';
        order = 'ASC';
        meta_key = '_price';
      } else if (sortSelected == 'price-desc') {
        orderby = 'meta_value_num';
        order = 'DESC';
        meta_key = '_price';
      }

      // Price
      var price_from = parseInt($('.range-min').text());
      var price_to = parseInt($('.range-max').text());

      // Search
      var query = '';
      if ($('input[name="search-query"]').val() !== '') {
        query = $('input[name="search-query"]').val();
      }

      // Current page
      var current_page = parseInt($loadMore.data('page'));

      $.ajax({
        url: '/wp-json/shop-api/v1/get',
        data: {
          page: current_page,
          cats: categories,
          orderby: orderby,
          order: order,
          meta_key: meta_key,
          search_term: query,
          price_from: price_from,
          price_to: price_to,
          lang: $('body').data('lang'),
          ignore_price: ignore_price,
        },
      })
        .done(function (res) {


          $('.range-label').removeClass('d-none').addClass('d-block');

          // Append posts to page.

          res.result_data.forEach(function (post) {

            // const lang = $('html').attr('lang');
            const post_permalink = post.permalink;// + '?lang=' + (lang == 'cy-GB' ? 'cy' : 'en');

            var o = `
                <div class="col-12 col-sm-6 col-lg-3 product mb-5">
                  <a href="${post_permalink}">
                    <div class="product-thumb" style="background-image: url('${post.thumb}');"></div>
                    <span class="product-title">${post.title}</span>
                    <span class="product-price">&pound;${post.price}</span>
                  </a>
                </div>`;

            $('.products-container').append(o);

            if (parseInt(res.showing_results_to) < parseInt(res.total_results)) {
              $('#load-more').fadeIn();
            }
          })

          const resultCountShowing = $('#result-count-showing').html();
          const resultCountOf = $('#result-count-of').html();
          const resultCountResults = $('#result-count-results').html();
          $('.woocommerce-result-count').html(`${resultCountShowing} 1 - ${res.showing_results_to} ${resultCountOf} ${res.total_results} ${resultCountResults}`);

          /**
           * Update page.
           */
          $('#load-more').data('page', current_page + 1);
          in_progress = false;
          unfreeze_filters();

          /**
           * Update price filter
           */
          var range_min = parseInt(res.min_price);
          var range_max = parseInt(res.max_price);

          if (range_min < 0) {
            range_min = 0;
          }

          if (range_max <= range_min) {
            range_max = range_min + 1;
          }

          if ($('.range').data('range-min') != range_min || $('.range').data('range-max') != range_max) {
            $('.range-holder').empty().append('<div class="range"></div>');
            var range_slider = $('.range').get()[0];

            noUiSlider.create(range_slider, {
              start: [range_min, range_max],
              connect: [false, true, false],
              range: {
                'min': range_min,
                'max': range_max,
              },
            });

            $('.range').data('range-min', range_min);
            $('.range').data('range-max', range_max);

            range_slider.noUiSlider.on('update', function (values) {
              $('.range-min').text(values[0]);
              $('.range-max').text(values[1]);
            });

            range_slider.noUiSlider.on('change', function () {
              $('.products-container').empty();
              $('#load-more').data('page', 1);
              load_products(false);
            });
          }

          spinner.remove();
        })
        .error(function () {
          in_progress = false;
          unfreeze_filters();
          spinner.remove();
        })
    }

    function freeze_filters() {
      $('input[name="product_cat"]').prop('disabled', true);
      document.getElementsByClassName('range')[0].setAttribute('disabled', true);
      $('input[name="search-query"]').prop('disabled', true);
      $('select[name="orderby"]').prop('disabled', true);
    }

    function unfreeze_filters() {
      $('input[name="product_cat"]').prop('disabled', false);
      document.getElementsByClassName('range')[0].removeAttribute('disabled');
      $('input[name="search-query"]').prop('disabled', false);
      $('select[name="orderby"]').prop('disabled', false);
    }

    $loadMore.on('click', function () {
      load_products(false);
    });

    $('#shop-form').on('submit', function(e) {
      e.preventDefault();
    });

    $('input[name="product_cat"]').on('change', function () {
      if ($(this).val() != 'category-all') {
        $('#category-all').prop('checked', false);
      }

      /**
       * Always have at least one item checked
       */
      var noMoreChecked = true;
      if (!$(this).prop('checked')) {
        $('input[name="product_cat"]').each(function () {
          if ($(this).prop('checked')) {
            noMoreChecked = false;
          }
        });

        if (noMoreChecked) {
          $(this).prop('checked', true);
        }
      } else {
        noMoreChecked = false;
      }

      if (!noMoreChecked) {
        $('.products-container').empty();
        $('#load-more').data('page', 1);
        load_products();
      }
    });

    $('input[name="search-query"]').on('keyup', function () {
      const $this_ = $(this);
      const textSoFar = $this_.val();

      setTimeout(function () {
        if ($this_.val() == textSoFar) {
          $('.products-container').empty();
          $('#load-more').data('page', 1);
          load_products();
        }
      }, 1000);
    });

    $('select[name="orderby"]').on('change', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $('.products-container').empty();
      $('#load-more').data('page', 1);
      load_products();
    });

    // Set category by URL
    const urlParams = new URLSearchParams(window.location.search);
    const query_category = urlParams.get('category');

    if (query_category) {
      $(`input[name="product_cat"]#${query_category}`).trigger('click');
    }

    load_products();
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive.js